import { Component } from '@angular/core';

import { ButtonModule } from 'primeng/button';
import { RippleModule } from 'primeng/ripple';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';

@Component({
  selector: 'app-order-return-dialog-success',
  standalone: true,
  imports: [ButtonModule, RippleModule],
  templateUrl: './order-return-dialog-success.component.html',
  styleUrl: './order-return-dialog-success.component.scss'
})
export class OrderReturnDialogSuccessComponent {
  public dialogData: any;
  constructor(private dialogRef: DynamicDialogRef, private config: DynamicDialogConfig){
    this.dialogData = this.config.data;
  }

  public closeDialog(){
    this.dialogRef.close()
  }
}
